import React, { useState, useEffect } from 'react'
import { BehaviorSubject, Subject } from 'rxjs';
import * as _ from "lodash";


const SIX_MONTHS_MS = 15552000000 //180*24*60*60*1000 (180 days)
const SSE_INACTIVITY_PERIOD = 5000;
const DEFAULT_MAX_DURATION = 30000; // 30s absolute safety net

/** POST call for refreshToken
 ReqBody - {refresh_token}
 */
 export const getHistoricalData = async (props) => {

    let historcalSyncDataSubscription;
    let autoStartTimerId;
    let absoluteTimerId;
    let isSSEstopped = true;

    const streamKey = props.streamKey ?? "history";
    const inactivityPeriod = props.inactivityPeriod ?? SSE_INACTIVITY_PERIOD;

    const signalDone = () => {
        if (isSSEstopped) return; // already signalled
        isSSEstopped = true;
        if (autoStartTimerId) clearTimeout(autoStartTimerId);
        if (absoluteTimerId) clearTimeout(absoluteTimerId);
        props.dtalService.unsubscribe(streamKey);
        props.duControlSubject.next(true);
    };

    const handlesseInactivity = () => {
        signalDone();
    };

        let currentDate = new Date();

        let totimestamp = currentDate.toISOString();
        let fromtimestamp = new Date(currentDate.getTime() - SIX_MONTHS_MS).toISOString();

        const historcalSyncData = await props.dtalService.gethistorical(props.identifier, null, null, props.fromtimestamp??fromtimestamp,
            props.totimestamp??totimestamp, props.fields??"thingId,attributes,features,_revision,_modified", streamKey)

        if (historcalSyncData) {
          isSSEstopped = false; //SSE started

          // Absolute safety-net timer — fires even if zero events arrive
          const maxDuration = props.maxDuration ?? DEFAULT_MAX_DURATION;
          absoluteTimerId = setTimeout(signalDone, maxDuration);

          historcalSyncDataSubscription = historcalSyncData.subscribe(response => {
            let existingEntry = null;

            //SSE
            if (autoStartTimerId) clearTimeout(autoStartTimerId); //cancel inactivity timer
            if (props.thingUpdates.size == 0) {
                props.thingUpdates.set(response._modified, response);
              autoStartTimerId = setTimeout(handlesseInactivity, inactivityPeriod); //start inactivity timer
            } else {
              existingEntry = props.thingUpdates.get(response._modified);
              if (existingEntry) {
                //stop SSE as data is getting repeated, trigger processing of device updates
                signalDone();

              } else {
                //found new entry, start inactivity timer
                props.thingUpdates.set(response._modified, response);
                autoStartTimerId = setTimeout(handlesseInactivity, inactivityPeriod);

              }
            }
          });
        } else {
          // historcalSyncData is null — signal immediately so consumers don't spin
          props.duControlSubject.next(true);
        }

        return historcalSyncDataSubscription;
}
